export const container = ({ theme: { colors } }) => ({
    display: 'inline-block',
    paddingBottom: '1.5rem',
    paddingRight: '1.5rem',
    fill: colors.cyan,
    transition: 'cubic-bezier(0.4, 0.0, 0.2, 1) fill 0.3s',

    ':last-child': {
        paddingRight: 0,
    },

    ':hover': {
        fill: colors.fuchsia,
    },

    ':active': {
        fill: colors.blue,
    },

    tablet: {
        paddingRight: '1.5rem',
        paddingBottom: '1.5rem',
    },
});
